import challengeFields from "../inputsConfig";

const { ideation: ideationFields } = challengeFields;
export default {
  accordion: false,
  items: [
    {
      name: "Reward Policy",
      required: true,
      description:
        "Select how rewards will be distributed to participants based on their performance",
      fields: ideationFields.reward_policy,
    },
    {
      name: "Challenge image",
      required: true,
      description:
        "Upload the image you would like to represent this challenge. If you'd prefer to use a video, skip this question and process to the next one.",
      fields: ideationFields.snapshot_pic,
    },
    {
      name: "Challenge title",
      required: true,
      description: "Provide a title for this challenge.",
      fields: ideationFields.title,
    },
    {
      name: "Challenge description",
      required: true,
      description:
        "Provide a brief description of the challenge and its purpose. Drag and drop images. Copy + Paste image/video URLs and they will be automatically embedded.",
      fields: ideationFields.description,
    },
    {
      name: "Supplemental Submission Fields",
      required: false,
      fields: ideationFields.supplemental_submission_fields,
    },
    {
      name: "Select Company Team",
      required: true,
      fields: ideationFields.company_team_id,
    },
  ],
};
